/**
 * EstadoEmbarqueChip — Muestra el estado de embarque del pasajero.
 *
 * Es INDEPENDIENTE del `estado` de la reserva (confirmada/completada/etc.).
 * Una reserva puede estar `confirmada` en el ciclo administrativo pero
 * `no_show` en lo operativo del día del pasadía — el operador necesita ver
 * ambos chips por separado.
 *
 * Estados de embarque:
 *   pendiente  → aún no ha ocurrido el pasadía o no se ha marcado
 *   cobrado    → cobro completo en muelle (aún no embarca)
 *   embarcado  → subió a la lancha
 *   no_show    → no se presentó al muelle
 */
import React from 'react';
import { Chip } from '@mui/material';

const CONFIG = {
  pendiente: { bg: '#f1f5f9', color: '#475569', label: 'Embarque: pendiente' },
  cobrado:   { bg: '#dbeafe', color: '#1e40af', label: 'Embarque: cobrado' },
  embarcado: { bg: '#dcfce7', color: '#166534', label: 'Embarcado' },
  no_show:   { bg: '#fee2e2', color: '#991b1b', label: 'No show' },
};

export default function EstadoEmbarqueChip({ estadoEmbarque, size = 'small' }) {
  // Si no viene el estado de embarque, no rendereamos nada — evita ruido en
  // reservas antiguas antes de que existiera el campo.
  if (!estadoEmbarque) return null;

  const cfg = CONFIG[estadoEmbarque] || {
    bg: '#e2e8f0', color: '#475569', label: `Embarque: ${estadoEmbarque}`,
  };

  return (
    <Chip
      size={size}
      label={cfg.label}
      sx={{
        bgcolor: cfg.bg,
        color: cfg.color,
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: 0.2,
      }}
    />
  );
}
